module.exports = __webpack_public_path__ + "f97e3bbf73254b0112091d0192f17aec.svg";


//////////////////
// WEBPACK FOOTER
// ./~/slick-carousel/slick/fonts/slick.svg
// module id = 694
// module chunks = 0